import { createFileRoute } from '@tanstack/react-router'
import { SensorKitValidateSensorPlacementsPage } from "@/sync/SensorKitValidateSensorPlacementsPage";

export const Route = createFileRoute('/sync/$sensorKitSerialNumber/validate')({
  component: RouteComponent,
})

function RouteComponent() {
  const { sensorKitSerialNumber } = Route.useParams()
  return <SensorKitValidateSensorPlacementsPage sensorKitSerialNumber={sensorKitSerialNumber}/>
}
